import React, { useState, useRef } from 'react';
import Flickity from 'react-flickity-component';
import { map } from 'lodash';
import common from '../../../common/common';
import ProductCard from './ProductCard.jsx';

import './ProductSlider.scss';

function ProductSlider({ products }) {
    const flcktyHtmlRef = useRef(null);
    const [flcktyRef, setRef] = useState(undefined);
    const flcktyOption = {
        autoPlay: false,
        cellAlign: 'left',
        contain: true,
        draggable: common.isTouch(),
        pageDots: false,
        prevNextButtons: true,
        wrapAround: false,
        groupCells: '100%',
        lazyLoad: 5,
    };

    const result = map(products, (p, idx) => (
        <div key={idx} className='slider-item'>
            <ProductCard p={p} />
        </div>
    ));

    return (
        <Flickity
            className='product-slider'
            ref={flcktyHtmlRef}
            flickityRef={(c) => {
                setRef(c);
            }}
            options={flcktyOption}>
            {result}
        </Flickity>
    );
}

export default ProductSlider;
